import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { OperationHistory, OperationHistoryParams } from "@/entity/logistics/operationHistory";

export class OperationHistoryService extends BaseService<OperationHistory, unknown, OperationHistoryParams, unknown> {
    public async getDetail(params: OperationHistoryParams): Promise<OperationHistory[]> {
        const { data } = await this.service.get(`${this.path}/findByModule`, { params });
        return data;
    }
}

export const operationHistoryService = new OperationHistoryService("/admin/operationHistory", request.service);
